module.exports = __webpack_public_path__ + "img/guinea-bissau.2d8f1c61.svg";